import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncWithdrawContractConsents = loadable(
  () => import('./Consents'),
  { fallback: <Loader /> },
);
